import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { FilterBarContainer } from '../../header/filterBar/FilterBarContainer';
import { PriorityRender } from '../../loadable/lib/PriorityRender';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Flex } from 'foundations-components/components/Flex';
import { UndoIcon, DuplicateIcon, SaveEditableViewIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilterBarPlaceholder = () => {
  return /*#__PURE__*/_jsx(FilterBarContainer, {
    startSlot: /*#__PURE__*/_jsx(LoadingSpinner, {}),
    endSlot: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(IconButton, {
        disabled: true,
        size: "sm",
        use: "tertiary-extra-light",
        children: /*#__PURE__*/_jsx(UndoIcon, {})
      }), /*#__PURE__*/_jsx(IconButton, {
        disabled: true,
        size: "sm",
        use: "tertiary-extra-light",
        marginInlineStart: "100",
        children: /*#__PURE__*/_jsx(DuplicateIcon, {})
      }), /*#__PURE__*/_jsx(IconButton, {
        disabled: true,
        size: "sm",
        use: "tertiary-extra-light",
        marginInlineStart: "100",
        children: /*#__PURE__*/_jsx(SaveEditableViewIcon, {})
      })]
    })
  });
};
const loadFilterBarWrapper = () => import( /* webpackChunkName: "filter-bar-wrapper" */'./FilterBarWrapper');
const AsyncRenderFilterBarWrapper = () => {
  return /*#__PURE__*/_jsx(PriorityRender, {
    priority: "low",
    LoadingComponent: FilterBarPlaceholder,
    loader: loadFilterBarWrapper,
    LOGGING_COMPONENT_NAME: "AsyncRenderFilterBarWrapper"
  });
};
export default AsyncRenderFilterBarWrapper;